class Share {

    constructor() {
        this.url = $('meta[property="og:url"]').attr('content');
        this.title = $('meta[property="og:title"]').attr('content');
        this.image = $('meta[property="og:image"]').attr('content');
        this.text = $('meta[property="og:description"]').attr('content');
    }

    vk() {
        let url  = 'http://vkontakte.ru/share.php?';

        url += 'url='          + encodeURIComponent(this.url);
        url += '&title='       + encodeURIComponent(this.title);
        url += '&description=' + encodeURIComponent(this.text);
        url += '&image='       + encodeURIComponent(this.image);
        url += '&noparse=true';

        this.popup(url);
    }

    ok() {
        let url  = 'http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1';

        url += '&st.comments=' + encodeURIComponent(this.text);
        url += '&st._surl='    + encodeURIComponent(this.url);

        this.popup(url);
    }

    fb() {
        let url  = 'http://www.facebook.com/sharer.php?';

        url += 'u=' + encodeURIComponent(this.url);

        this.popup(url);
    }

    tw() {
        let url  = 'http://twitter.com/share?';

        url += 'text='      + encodeURIComponent(this.title);
        url += '&url='      + encodeURIComponent(this.url);
        url += '&counturl=' + encodeURIComponent(this.url);

        this.popup(url);
    }

    mr() {
        let url  = 'http://connect.mail.ru/share?';

        url += 'url='          + encodeURIComponent(this.url);
        url += '&title='       + encodeURIComponent(this.title);
        url += '&description=' + encodeURIComponent(this.text);
        url += '&imageurl='    + encodeURIComponent(this.image);

        this.popup(url);
    }

    popup(url) {
        window.open(url,'','toolbar=0,status=0,width=626,height=436');
    }
}

let share = new Share();

export default share;



// WEBPACK FOOTER //
// ./_src/js/share.js